import Section from 'components/Section'
import { WorkspaceSettingsProfileQuery } from 'modules/workspaceProfile/containers/WorkspaceSettingsProfileQuery'
import React from 'react'

export interface WorkspaceSettingsProfileProps {
  workspaceId: string
}

export const WorkspaceSettingsProfile: React.FC<WorkspaceSettingsProfileProps> = props => {
  return (
    <Section title="Visibility">
      <WorkspaceSettingsProfileQuery {...props} />
    </Section>
  )
}
